var _rect, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEmptyFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2052_18761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 8,
    width: 127,
    height: 93
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 127,
    height: 93,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2052_18761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3359 34C22.3359 25.1634 29.4994 18 38.3359 18H86.5999C95.4365 18 102.6 25.1634 102.6 34V106.032H22.3359V34Z",
    fill: "#F8F8F8",
    stroke: "#E9E9E9",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5537,
    y: 70.5,
    width: 61.0458,
    height: 21,
    rx: 5.5,
    fill: "#E9E9E9",
    stroke: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4922,
    y: 37.5,
    width: 30.9924,
    height: 4,
    rx: 2,
    fill: "#E9E9E9",
    stroke: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4922,
    y: 47.5,
    width: 30.9924,
    height: 5,
    rx: 2.5,
    fill: "#E9E9E9",
    stroke: "#E9E9E9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.771 36C71.771 33.7909 73.5619 32 75.771 32H89.0992C91.3084 32 93.0992 33.7909 93.0992 36V58.188C93.0992 58.9116 92.2578 59.3096 91.6984 58.8506L83.5225 52.1422C82.8904 51.6235 81.9799 51.6235 81.3477 52.1422L73.1718 58.8506C72.6124 59.3096 71.771 58.9116 71.771 58.188V36Z",
    fill: "#E9E9E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyFeedback);
export default __webpack_public_path__ + "static/media/ic_empty_feedback.d3c2cabad3f7f4801ee5ca945b9a8077.svg";
export { ForwardRef as ReactComponent };